import { MobilePageLayout } from '../../layouts/mobile/MobilePageLayout';
import { useShowMobileLayout } from '../../utils/LayoutUtils';
import { useIsChairside } from '../../utils/chairside.hooks';
import { PatientsList } from './components/patients-overview/PatientsList.graphql';
import { PatientsOverviewToolbar } from './components/patients-overview/PatientsOverviewToolbar.graphql';
import { styled } from '@orthly/ui-primitives';
import { PracticeBanner } from '@orthly/veneer';
import React from 'react';

const Layout = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
});

const PatientsOverviewInner: React.VFC = () => {
    return (
        <Layout>
            <PracticeBanner
                banner={{
                    title: "Patients are displayed on this page when they've had at least one order or Diagnostic Scan submitted.",
                    type: 'info',
                }}
            />
            <PatientsOverviewToolbar />
            <PatientsList />
        </Layout>
    );
};

export const PatientsOverviewRoot: React.VFC = () => {
    const chairside = useIsChairside();
    const isMobileLayout = useShowMobileLayout();

    if (isMobileLayout && !chairside) {
        return (
            <MobilePageLayout title={'Patients'}>
                <PatientsOverviewInner />
            </MobilePageLayout>
        );
    }

    return <PatientsOverviewInner />;
};
